import chatService from "./chatService";

const service = {
	chatService: chatService,
};

export default service;
